// Centralized data store for litter profiles
import { dogProfiles } from './dogProfiles';
// Unused while the Cookie & Dume litter is commented out.
// import { externalDogs } from './externalDogs';

export const litterProfiles = {
  litters: [
    {
      id: 'tonks-dume-2026-08',
      title: 'Tonks & Dume Litter',
      // Lowest displayOrder renders first on the Available Puppies page;
      // change these numbers to reorder the page.
      displayOrder: 2,
      parents: {
        mother: dogProfiles.tonks,
        father: dogProfiles.dume
      },
      birthDate: '9/2/2026',
      readyDate: '10/29/2026',
      availablePuppies: [
        {
          id: 1,
          name: 'Ripley',
          gender: 'Female',
          color: 'Blue Merle',
          markings: 'Blue Merle',
          status: 'Available',
          pet_price: '$4,000',
          backgroundPosition: 'center center',
          photo_index: '/dog-photos/puppy-gallery/ripley/index.json'
        },
        {
          id: 2,
          name: 'Nancy',
          gender: 'Female',
          color: 'Lilac & Tan',
          markings: 'Lilac & Tan',
          status: 'Available',
          pet_price: '$2,500',
          price_reduction: {
            original_price: '$3,000',
            reason: 'Nancy has a small umbilical hernia. She has been examined and cleared by our vet, and her price was reduced to cover the cost of the repair surgery.',
            learn_more: '/health#umbilical-hernia'
          },
          backgroundPosition: 'center center',
          photo_index: '/dog-photos/puppy-gallery/nancy/index.json'
        },
        {
          id: 3,
          name: 'Sidney',
          gender: 'Female',
          color: 'Blue Merle',
          markings: 'Blue Merle',
          status: 'Available',
          pet_price: '$4,000',
          backgroundPosition: 'center center',
          photo_index: '/dog-photos/puppy-gallery/sidney/index.json'
        },
        {
          id: 4,
          name: 'Freddy',
          gender: 'Male',
          color: 'Lilac & Tan',
          markings: 'Lilac & Tan Fluffy',
          status: 'Unavailable',
          pet_price: '$4,000',
          backgroundPosition: 'center center',
          photo_index: '/dog-photos/puppy-gallery/freddy/index.json'
        },
        {
          id: 5,
          name: 'Jason',
          gender: 'Male',
          color: 'Lilac Merle',
          markings: 'Lilac Merle',
          status: 'Available',
          pet_price: '$4,000',
          backgroundPosition: 'center center',
          photo_index: '/dog-photos/puppy-gallery/jason/index.json'
        },
        {
          id: 6,
          name: 'Clarice',
          gender: 'Female',
          color: 'Blue & Tan',
          markings: 'Blue & Tan',
          status: 'Available',
          pet_price: '$2,500',
          price_reduction: {
            original_price: '$3,000',
            reason: 'Clarice has an inguinal hernia and an umbilical hernia. She has been examined and cleared by our vet, and her price was reduced to cover the cost of the repair surgery.',
            learn_more: '/health'
          },
          backgroundPosition: 'center center',
          photo_index: '/dog-photos/puppy-gallery/clarice/index.json'
        }
      ],
      gallery: '/dog-photos/puppies/current-litter',
      description: ''
    }
    // Opal sold - Cookie & Dume litter hidden.
    // {
    //   // Stud-out / pup-back litter: Cookie belongs to another breeder, so she
    //   // is an external parent (see src/data/externalDogs.js) rather than a
    //   // dogProfiles entry.
    //   id: 'cookie-dume-2026-08',
    //   title: 'Cookie & Dume Litter',
    //   displayOrder: 1,
    //   parents: {
    //     mother: externalDogs.cookie,
    //     father: dogProfiles.dume
    //   },
    //   birthDate: '8/11/2026',
    //   readyDate: '10/7/2026',
    //   // Only the pup we take back is listed; the rest of the litter is sold
    //   // by Cookie's owner.
    //   availablePuppies: [
    //     {
    //       id: 1,
    //       name: 'Opal',
    //       gender: 'Female',
    //       color: 'Cream',
    //       markings: 'Cream Merle',
    //       status: 'Unavailable',
    //       pet_price: '$2,500',
    //       // Shows a "Price Reduced" badge with the old price struck through.
    //       // learn_more points at a section of the Health Info page.
    //       price_reduction: {
    //         original_price: '$3,000',
    //         reason: 'Opal has a small inguinal hernia. She has been examined and cleared by our vet, and her price was reduced to cover the cost of the repair surgery.',
    //         learn_more: '/health#inguinal-hernia'
    //       },
    //       backgroundPosition: 'center center',
    //       photo_index: '/dog-photos/puppy-gallery/opal/index.json'
    //     }
    //   ],
    //   gallery: '/dog-photos/puppies/current-litter',
    //   description: ''
    // },
    // {
    //   id: 'pearl-hotsauce-2025-08',
    //   title: 'Pearl & Hot Sauce Litter',
    //   parents: {
    //     mother: dogProfiles.pearl,
    //     father: dogProfiles.hotsauce
    //   },
    //   birthDate: '8/11/2025',
    //   readyDate: '10/6/2025',
    //   availablePuppies: [
    //     {
    //       id: 1,
    //       name: 'Neo',
    //       gender: 'Male',
    //       color: 'Blue Merle',
    //       markings: 'Blue Merle',
    //       backgroundPosition: 'center 50%',
    //       temperament: 'Playful and affectionate',
    //       status: 'Available',
    //       weight: '12 lbs at 8 weeks',
    //       pet_price: '$4,000',
    //       photo_index: '/dog-photos/puppy-gallery/neo/index.json'
    //     }
    //   ],
    //   gallery: '/dog-photos/puppies/current-litter',
    //   description: 'A beautiful litter of French Bulldog puppies with exceptional genetics from our champion bloodlines. All puppies inherit the best traits from Zannah and Revan, including their stunning blue coats and excellent temperaments. Each puppy has been health-checked and socialized from birth.'
    // },
    //     {
    //   id: 'zannanh-dume-2025-10',
    //   title: 'Zannah & Dume Litter',
    //   parents: {
    //     mother: dogProfiles.zannah,
    //     father: dogProfiles.dume
    //   },
    //   birthDate: '10/22/2025',
    //   readyDate: '12/17/2025',
    //   availablePuppies: [
    //     {
    //       id: 1,
    //       name: 'Cider',
    //       gender: 'Female',
    //       color: 'Sable Merle',
    //       markings: 'Sable Merle',
    //       backgroundPosition: 'center 10%',
    //       temperament: 'Playful and affectionate',
    //       status: 'Unavailable',
    //       weight: '12 lbs at 8 weeks',
    //       pet_price: '$2,500',
    //       photo_index: '/dog-photos/puppy-gallery/cider/index.json'
    //     },
    //     {
    //       id: 2,
    //       name: 'Jingles',
    //       gender: 'Male',
    //       color: 'Sable',
    //       markings: 'Sable',
    //       backgroundPosition: 'center 30%',
    //       temperament: 'Playful and affectionate',
    //       status: 'Unavailable',
    //       weight: '12 lbs at 8 weeks',
    //       pet_price: '$1,500',
    //       photo_index: '/dog-photos/puppy-gallery/jingles/index.json'
    //     },
    //     {
    //       id: 3,
    //       name: 'Holly',
    //       gender: 'Female',
    //       color: 'Cream Merle',
    //       markings: 'Cream Merle',
    //       backgroundPosition: 'center 10%',
    //       temperament: 'Playful and affectionate',
    //       status: 'Unavailable',
    //       weight: '12 lbs at 8 weeks',
    //       pet_price: '$2,500',
    //       photo_index: '/dog-photos/puppy-gallery/holly/index.json'
    //     },
    //     {
    //       id: 4,
    //       name: 'Spruce',
    //       gender: 'Male',
    //       color: 'Cream Merle',
    //       markings: 'Cream Merle',
    //       backgroundPosition: 'center 20%',
    //       temperament: 'Playful and affectionate',
    //       status: 'Unavailable',
    //       weight: '12 lbs at 8 weeks',
    //       pet_price: '$2,500',
    //       photo_index: '/dog-photos/puppy-gallery/spruce/index.json'
    //     },
    //     {
    //       id: 5,
    //       name: 'Cookie',
    //       gender: 'Female',
    //       color: 'Sable Merle',
    //       markings: 'Sable Merle',
    //       backgroundPosition: 'center 0%',
    //       temperament: 'Playful and affectionate',
    //       status: 'Unavailable',
    //       weight: '12 lbs at 8 weeks',
    //       pet_price: '$3,000',
    //       photo_index: '/dog-photos/puppy-gallery/cookie/index.json'
    //     },
    //     {
    //       id: 6,
    //       name: 'FiggyPudding',
    //       gender: 'Female',
    //       color: 'Sable',
    //       markings: 'Sable',
    //       backgroundPosition: 'center 0%',
    //       temperament: 'Playful and affectionate',
    //       status: 'Unavailable',
    //       weight: '12 lbs at 8 weeks',
    //       pet_price: '$2,000',
    //       photo_index: '/dog-photos/puppy-gallery/figgypudding/index.json'
    //     },
    //     {
    //       id: 7,
    //       name: 'Yeti',
    //       gender: 'Male',
    //       color: 'Cream Merle',
    //       markings: 'Cream Merle',
    //       backgroundPosition: 'center 30%',
    //       temperament: 'Playful and affectionate',
    //       status: 'Unavailable',
    //       weight: '12 lbs at 8 weeks',
    //       pet_price: '$2,000',
    //       photo_index: '/dog-photos/puppy-gallery/yeti/index.json'
    //     }
    //   ],
    //   gallery: '/dog-photos/puppies/current-litter',
    //   description: ''
    // }
  ]
};